module.exports = __webpack_public_path__ + "img/index-t-slide5.e0486663.png";